import { toURLSearchParams } from '@wix/metro-runtime';
import { serializer } from '@wix/metro-runtime/ambassador';
import { resolveUrl } from '@wix/metro-runtime';
var _addLocationTypeRequest = {};
var _addLocationTypeResponse = { location: '_location' };
var _address = { geocode: '_addressLocation' };
var _addressLocation = {
    latitude: 'google.protobuf.DoubleValue',
    longitude: 'google.protobuf.DoubleValue',
};
var _archiveLocationRequest = {};
var _archiveLocationResponse = { location: '_location' };
var _bulkCreateLocationRequest = { locations: '_location' };
var _bulkCreateLocationResponse = {
    successfulLocations: '_location',
    failedLocations: '_failedCreateLocation',
};
var _bulkUpdateLocationRequest = { locations: '_location' };
var _bulkUpdateLocationResponse = { successfulLocations: '_location' };
var _createLocationRequest = { location: '_location' };
var _createLocationResponse = { location: '_location' };
var _failedCreateLocation = { location: '_location' };
var _getLocationRequest = {};
var _getLocationResponse = { location: '_location' };
var _listLocationsRequest = {};
var _listLocationsResponse = { locations: '_location' };
var _location = { address: '_address' };
var _queryLocationsRequest = {};
var _queryLocationsResponse = { locations: '_location' };
var _removeLocationTypeRequest = {};
var _removeLocationTypeResponse = { location: '_location' };
var _setDefaultLocationRequest = {};
var _setDefaultLocationResponse = { location: '_location' };
var _updateLocationRequest = { location: '_location' };
var _updateLocationResponse = { location: '_location' };
function resolveComWixpressLocationsLocationsServiceUrl(opts) {
    var domainToMappings = {
        'api._api_base_domain_': [
            {
                srcPath: '/locations-web',
                destPath: '',
            },
        ],
        'manage._base_domain_': [
            {
                srcPath: '/_api/locations-web',
                destPath: '',
            },
        ],
        'www._base_domain_': [
            {
                srcPath: '/_api/locations-web',
                destPath: '',
            },
        ],
        'www.wixapis.com': [
            {
                srcPath: '/locations/v1/locations',
                destPath: '/v1/locations',
            },
        ],
        'apps._base_domain_': [
            {
                srcPath: '/_api/locations-web',
                destPath: '',
            },
        ],
        'editor.wixapps.net': [
            {
                srcPath: '/_api/locations-web',
                destPath: '',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
/** Creates a location. */
export function createLocation(payload) {
    var _a = serializer(_createLocationRequest, { _address: _address, _addressLocation: _addressLocation, _location: _location }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_createLocationResponse, {
        _address: _address,
        _addressLocation: _addressLocation,
        _location: _location,
    }).fromJSON;
    function __createLocation(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.locations.v1.location',
            method: 'POST',
            methodFqn: 'com.wixpress.locations.LocationsService.CreateLocation',
            url: resolveComWixpressLocationsLocationsServiceUrl({
                protoPath: '/v1/locations',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __createLocation.fromReq = fromReq;
    __createLocation.__isAmbassador = true;
    return __createLocation;
}
/** Creates locations in bulk. */
export function bulkCreateLocation(payload) {
    var _a = serializer(_bulkCreateLocationRequest, { _address: _address, _addressLocation: _addressLocation, _location: _location }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_bulkCreateLocationResponse, {
        _address: _address,
        _addressLocation: _addressLocation,
        _failedCreateLocation: _failedCreateLocation,
        _location: _location,
    }).fromJSON;
    function __bulkCreateLocation(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.locations.v1.location',
            method: 'POST',
            methodFqn: 'com.wixpress.locations.LocationsService.BulkCreateLocation',
            url: resolveComWixpressLocationsLocationsServiceUrl({
                protoPath: '/v1/locations/bulk-create',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __bulkCreateLocation.fromReq = fromReq;
    __bulkCreateLocation.__isAmbassador = true;
    return __bulkCreateLocation;
}
/** Retrieves a location. */
export function getLocation(payload) {
    var _a = serializer(_getLocationRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getLocationResponse, {
        _address: _address,
        _addressLocation: _addressLocation,
        _location: _location,
    }).fromJSON;
    function __getLocation(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.locations.v1.location',
            method: 'GET',
            methodFqn: 'com.wixpress.locations.LocationsService.GetLocation',
            url: resolveComWixpressLocationsLocationsServiceUrl({
                protoPath: '/v1/locations/{id}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getLocation.fromReq = fromReq;
    __getLocation.__isAmbassador = true;
    return __getLocation;
}
/** Retrieves locations, given the provided filters, sorting, and paging. */
export function listLocations(payload) {
    var _a = serializer(_listLocationsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_listLocationsResponse, {
        _address: _address,
        _addressLocation: _addressLocation,
        _location: _location,
    }).fromJSON;
    function __listLocations(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.locations.v1.location',
            method: 'GET',
            methodFqn: 'com.wixpress.locations.LocationsService.ListLocations',
            url: resolveComWixpressLocationsLocationsServiceUrl({
                protoPath: '/v1/locations',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __listLocations.fromReq = fromReq;
    __listLocations.__isAmbassador = true;
    return __listLocations;
}
/**
 * Replaces a location.
 *
 *
 * > **Note:** Currently, it isn't possible to partially update a location. Therefore, you'll need to pass the full location object in the body of the call.
 */
export function updateLocation(payload) {
    var _a = serializer(_updateLocationRequest, { _address: _address, _addressLocation: _addressLocation, _location: _location }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_updateLocationResponse, {
        _address: _address,
        _addressLocation: _addressLocation,
        _location: _location,
    }).fromJSON;
    function __updateLocation(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.locations.v1.location',
            method: 'PUT',
            methodFqn: 'com.wixpress.locations.LocationsService.UpdateLocation',
            url: resolveComWixpressLocationsLocationsServiceUrl({
                protoPath: '/v1/locations/{location.id}',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __updateLocation.fromReq = fromReq;
    __updateLocation.__isAmbassador = true;
    return __updateLocation;
}
/**
 * Replaces locations in bulk.
 *
 *
 * > **Note:** Currently, it isn't possible to partially update a location. Therefore, you'll need to pass the full location object in the body of the call.
 */
export function bulkUpdateLocation(payload) {
    var _a = serializer(_bulkUpdateLocationRequest, { _address: _address, _addressLocation: _addressLocation, _location: _location }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_bulkUpdateLocationResponse, {
        _address: _address,
        _addressLocation: _addressLocation,
        _location: _location,
    }).fromJSON;
    function __bulkUpdateLocation(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.locations.v1.location',
            method: 'PUT',
            methodFqn: 'com.wixpress.locations.LocationsService.BulkUpdateLocation',
            url: resolveComWixpressLocationsLocationsServiceUrl({
                protoPath: '/v1/locations/bulk-update',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __bulkUpdateLocation.fromReq = fromReq;
    __bulkUpdateLocation.__isAmbassador = true;
    return __bulkUpdateLocation;
}
/** Retrieves locations, given the provided filters, sorting, and paging. */
export function queryLocations(payload) {
    var _a = serializer(_queryLocationsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_queryLocationsResponse, {
        _address: _address,
        _addressLocation: _addressLocation,
        _location: _location,
    }).fromJSON;
    function __queryLocations(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.locations.v1.location',
            method: 'POST',
            methodFqn: 'com.wixpress.locations.LocationsService.QueryLocations',
            url: resolveComWixpressLocationsLocationsServiceUrl({
                protoPath: '/v1/locations/query',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __queryLocations.fromReq = fromReq;
    __queryLocations.__isAmbassador = true;
    return __queryLocations;
}
/**
 * Sets a new default location.
 *
 *
 * > **Notes:**
 * > + There can only be one default location per site.
 * > + The default location can't be archived.
 */
export function setDefaultLocation(payload) {
    var _a = serializer(_setDefaultLocationRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_setDefaultLocationResponse, {
        _address: _address,
        _addressLocation: _addressLocation,
        _location: _location,
    }).fromJSON;
    function __setDefaultLocation(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.locations.v1.location',
            method: 'POST',
            methodFqn: 'com.wixpress.locations.LocationsService.SetDefaultLocation',
            url: resolveComWixpressLocationsLocationsServiceUrl({
                protoPath: '/v1/locations/{id}/set-default',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __setDefaultLocation.fromReq = fromReq;
    __setDefaultLocation.__isAmbassador = true;
    return __setDefaultLocation;
}
/**
 * Archives a location.
 *
 *
 * > **Notes:**
 * > + Changes the `archived` boolean of a location to `true`.
 * > + You can't change a location's `status` using this endpoint.
 * > + Archived locations can't be updated.
 * > + Currently, it isn't possible to unarchive locations.
 * > + The `default` location can't be archived.
 */
export function archiveLocation(payload) {
    var _a = serializer(_archiveLocationRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_archiveLocationResponse, {
        _address: _address,
        _addressLocation: _addressLocation,
        _location: _location,
    }).fromJSON;
    function __archiveLocation(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.locations.v1.location',
            method: 'POST',
            methodFqn: 'com.wixpress.locations.LocationsService.ArchiveLocation',
            url: resolveComWixpressLocationsLocationsServiceUrl({
                protoPath: '/v1/locations/{id}/archive',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __archiveLocation.fromReq = fromReq;
    __archiveLocation.__isAmbassador = true;
    return __archiveLocation;
}
export function addLocationType(payload) {
    var _a = serializer(_addLocationTypeRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_addLocationTypeResponse, {
        _address: _address,
        _addressLocation: _addressLocation,
        _location: _location,
    }).fromJSON;
    function __addLocationType(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.locations.v1.location',
            method: 'PATCH',
            methodFqn: 'com.wixpress.locations.LocationsService.AddLocationType',
            url: resolveComWixpressLocationsLocationsServiceUrl({
                protoPath: '/v1/locations/{id}/add-location-type',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __addLocationType.fromReq = fromReq;
    __addLocationType.__isAmbassador = true;
    return __addLocationType;
}
export function removeLocationType(payload) {
    var _a = serializer(_removeLocationTypeRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_removeLocationTypeResponse, {
        _address: _address,
        _addressLocation: _addressLocation,
        _location: _location,
    }).fromJSON;
    function __removeLocationType(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.locations.v1.location',
            method: 'PATCH',
            methodFqn: 'com.wixpress.locations.LocationsService.RemoveLocationType',
            url: resolveComWixpressLocationsLocationsServiceUrl({
                protoPath: '/v1/locations/{id}/remove-location-type',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __removeLocationType.fromReq = fromReq;
    __removeLocationType.__isAmbassador = true;
    return __removeLocationType;
}
//# sourceMappingURL=http.impl.js.map